$(document).ready(function () {
    if (simPRODefaults.data('notificationenabled')) {
        //Step1: Get the config
        let firebaseConfig = getFirebaseConfig();
        //Step2: Initialize Firebase, needs to happen with every refresh
        firebase.initializeApp(firebaseConfig);
        //Check if it is initialized
        if (firebase.apps.length) {
            //Even though we are registering the service worker everytime, it actually only registers the first time.
            //the subsequent calls to register just returns the first registration made
            if ('serviceWorker' in navigator && 'PushManager' in window) {
                initialiseServiceWorker();
            }
        }
    }

    $(document)
        .on('click', '.notificationsClearAll-js', notificationsClearAll)
        .on('click', '.showNotificationList-js', showNotificationList)
        .on('click', '.openNotificationUrl-js', openNotificationUrl)
        .on('click', '.removeNotification-js', removeNotification)
        .on('click', '.handoverAction-js', notificationHandoverAction)
        .on('click', '.notificationPopupHide-js', notificationPopupHide)
        .on('click', '.handoverActionOpenProject-js', handoverActionOpenProject)
        .on('click', '.showHandoverAccessDialogConfirm-js', showHandoverAccessDialogConfirm);

    $('.pushNotificationsList-js').on('click', function (e) {
        e.preventDefault();
        toggleNotificationList();
    });

    $('.notificationListContainer').on('scroll', throttleScroll(handlePushNotificationContainerScroll, 150));
});

// variables for popup
let pushNotificationIDs = [];
let pushNotificationsTimer = null;
// variables for dropdown
let pushNotificationsLoading = false;
let pushNotificationsTotal = null;         // Total notifications (bubble on the top bar)
let pushNotificationsCurrentLength = null; // Current items total in the notification dropdown list
let pushNotificationsCurrentMaxID = null;  // The current max ID, used to load in history items
let removePushNotificationIDs = [];
let pushNotificationsRemovalTimer = null;

/**
 * Initial service worker, Grant navigator permission, get firebase token & update it into DB if required
 * @returns {Promise<void>}
 */
async function initialiseServiceWorker() {
    let registration = await navigator.serviceWorker.register('/public/js/firebase-messaging-sw.js');
    let messaging = firebase.messaging();
    messaging.useServiceWorker(registration);
    //request permission
    if (messaging.requestPermission()) {
        //update token in the DB if it is not already updated
        if (sessionStorage.getItem('firebaseTokenUpdated') !== 'true') {
            let token = await messaging.getToken();
            updateToken(token);
        }

        // This method is only available in a Window context
        messaging.onMessage((payload) => {
            // Check the total of notifications receiving from firebase in a certain time
            delayLoadingPushNotifications(payload.data.ID);
        });
    }
}

/**
 * Handles clicks outside the notification list to auto-hide it
 *
 * @param e
 */
function hideNotificationsList(e) {
    //do not hide if the click happening inside the list, or in the notification popup, or if clicking on the notification icon again
    //let the toggleNotificationList() take care of it
    if (
        !$(e.target).closest('.notificationContainer').length
        && !$(e.target).closest('#notificationPopup').length
        && !$(e.target).closest('.pushNotificationsList-js').length
    ) {
        $('.notificationContainer').css('visibility', 'hidden');
    } else {
        //add back the click event
        $(document).one('mousedown', hideNotificationsList);
    }
}

/**
 * Load notifications from DB by given IDs when timer is ended
 * @param int notificationID
 */
function delayLoadingPushNotifications(notificationID) {
    pushNotificationIDs.push(notificationID);

    if (pushNotificationsTimer) {
        clearTimeout(pushNotificationsTimer);
    }

    pushNotificationsTimer = setTimeout(function () {
        // Load data from DB by given IDs
        loadAsyncNotifications(pushNotificationIDs);
        pushNotificationIDs = [];
    }, 800);
}

/**
 * Set the total notifications
 * @param int total
 */
function setNotificationTotal(total) {
    pushNotificationsTotal = total;
    updatePushNotificationBubble();
}

/**
 * Updates the overall total count of notifications
 * @param int delta
 */
function incrementNotificationTotal(delta) {
    pushNotificationsTotal += delta;
    updatePushNotificationBubble();
}

function updatePushNotificationBubble() {
    let $PushNotificationsTotals = $(".pushNotificationsTotal-js");
    let totalString = pushNotificationsTotal > 99 ? "99+" : pushNotificationsTotal;
    $PushNotificationsTotals.each(function () {
        let $TotalElement = $(this);
        $TotalElement.html(totalString);
        if (pushNotificationsTotal > 0) {
            $('#pushNotificationsBubble').css("visibility", "visible");
        } else {
            $('#pushNotificationsBubble').css("visibility", "hidden");
            $('#notificationContainer').css("visibility", "hidden");
            pushNotificationsCurrentMaxID = null;
        }
    });

    // Hide "Clear All" link if there are no items
    $('#notificationsClearAll-js').css(
        'display',
        (totalString > 0) ? 'inline' : 'none'
    );
}

/**
 * Once you start scrolling the callback is called and
 * then it is fired again after timeout instead of using scroll event and calling the callback everytime
 *
 * @callback callback
 * @param {int} limit
 * @returns {Function}
 */
function throttleScroll(callback, limit) {
    let throttling = false;
    return function () {
        if (!throttling) {
            callback.call();
            throttling = true;
            setTimeout(function () {
                callback.call();
                throttling = false;
            }, limit);
        }
    }
}

/**
 * Checks if the list is already loading,
 * if not checks if the scroll is at the end of list and loads the next set of the list
 */
function handlePushNotificationContainerScroll() {
    if (!pushNotificationsLoading && pushNotificationsCurrentLength < pushNotificationsTotal) {
        let $NotificationContainer = $('.notificationListContainer');
        let currentScrollPosition = $NotificationContainer.scrollTop() + $NotificationContainer.height();
        let maximumScrollPosition = $NotificationContainer.prop("scrollHeight") - 60;
        if (currentScrollPosition >= maximumScrollPosition) {
            pushNotificationsLoading = true;
            loadNotificationsList();
        }
    }
}

/**
 * Loads a particular notification and appends it to the drop down
 * @param {array} notificationIDs
 */
function loadAsyncNotifications(notificationIDs) {
    let $NotificationList = $(".notificationListContainer");
    $.ajax("/common/ajax/pushNotification/loadPushNotifications.php", {
        data: {
            "notificationIDs": notificationIDs,
            "loadDropDownList": pushNotificationsCurrentLength !== null
        },
        success: function (response) {
            // If we're still waiting for the totals to load in, don't adjust the current/total or add this to the drop down
            if (pushNotificationsTotal !== null) {
                incrementNotificationTotal(response.count);
                // Don't update current items total and dropdown list when the content for dropdown is null
                if (response.dropdown) {
                    pushNotificationsCurrentLength += response.count;
                    $NotificationList.prepend(response.dropdown);
                    addNotificationHighlight(notificationIDs);
                }
            }
            if (response.popup) {
                generateNotificationPopup(response.popup);
            }
        }
    });
}

/**
 * Generate Notification popup
 * @param {string} content
 */
function generateNotificationPopup(content) {
    $("#notificationPopup").remove();
    $("body")
        .append(content)
        .ready(function () {
            let delay = 5000;
            if($(content).hasClass("keepLong-js")) {
                delay = 10000;
            }
            $("#notificationPopup")
                .delay(delay)
                .fadeOut(1200, function () {
                    $(this).remove();
                });
        });
}

/**
 * Loads the next set of notifications from the users history
 * @param {array} newNotificationIDs
 */
function loadNotificationsList(newNotificationIDs) {
    //pushNotificationsTotal === null, covers if for some reason setNotificationTotal() wasn't called from common.src.js
    if (pushNotificationsCurrentLength < pushNotificationsTotal || pushNotificationsTotal === null) {
        let $NotificationLoader = $('.notificationListLoader');
        let limit = 10;
        $.ajax("/common/ajax/pushNotification/loadPushNotifications.php", {
            data: {
                "limit": limit,
                "currentMaxID": pushNotificationsCurrentMaxID
            },
            beforeSend: function () {
                $NotificationLoader.show();
            },
            success: function (response) {
                pushNotificationsCurrentLength += (response.count > limit) ? limit : response.count;
                pushNotificationsCurrentMaxID = response.currentMaxID;

                // Insert the new notifications before the loading items
                $(response.dropdown).insertBefore($NotificationLoader);

                if (newNotificationIDs) {
                    addNotificationHighlight(newNotificationIDs);
                }

                // If we've not hit the current total, update the total with response.count
                if (pushNotificationsCurrentLength < pushNotificationsTotal) {
                    setNotificationTotal(response.count);
                }
                $NotificationLoader.hide();
            },
            complete: function () {
                pushNotificationsLoading = false;
            }
        });
    }
}

/**
 * @param {array} newNotificationIDs
 */
function addNotificationHighlight(newNotificationIDs) {
    for (let i = 0; i < newNotificationIDs.length; i++) {
        $('.notificationContainer .notificationID' + newNotificationIDs[i]).addClass('highlightNotificationListItem');
    }
}

/**
 * @param e
 */
function openNotificationUrl(e) {
    let url = $(this).data('url');
    let newWindow = $(this).data('newWindow');

    if (!url) {
        return;
    }

    if (newWindow) {
        let location = url + '&iframe=true';
        let dimensions = "width=1175,height=740,left=100,top=100,resizable=no,scrollbars=yes";
        window.open(location, 'window', dimensions);

        return;
    }

    createDialog("link", url);

    return;
}

/**
 * @param e
 */
function removeNotification(e) {
    e.stopPropagation();
    let notificationID = $(this).data('id');
    removeNotificationFromPopupAndList(notificationID);
    delayRemovingPushNotifications(notificationID);
}

/**
 * Fires an ajax call to server after timeout, instead of firing an ajax call with every removal
 * @param {int} notificationID
 * @param null url
 */
function delayRemovingPushNotifications(notificationID, url) {
    removePushNotificationIDs.push(notificationID);

    // Clear the timeout if it's set, and there are less than 10 items waiting to be removed
    if (pushNotificationsRemovalTimer) {
        clearTimeout(pushNotificationsRemovalTimer);
    }

    pushNotificationsRemovalTimer = setTimeout(function () {
        $.ajax('/common/ajax/pushNotification/clearPushNotifications.php', {
            data: {
                "notificationIDs": removePushNotificationIDs
            },
            success: function (response) {
                if (typeof url !== "undefined" && response.removedCount > 0) {
                    hideLoadingImage();
                    window.location.href = url;
                }
            }
        });
        removePushNotificationIDs = [];
    }, 1500);
}

/**
 * @param e
 */
function notificationsClearAll(e) {
    e.preventDefault();

    let $NotificationListItems = $('.notificationListContainer').find(".notificationListItem");
    if ($NotificationListItems.length) {
        $NotificationListItems.remove();

        pushNotificationsCurrentLength = null;
        pushNotificationsTotal = 0;

        // Remove the popup if one is still displaying
        let $NotificationPopup = $('#notificationPopup');
        if ($NotificationPopup.length) {
            $NotificationPopup.remove();
        }

        updatePushNotificationBubble();
        $('.notificationContainer').css('visibility', 'hidden');
        $.ajax('/common/ajax/pushNotification/clearPushNotifications.php');
    }
}

function showNotificationList() {
    let newNotificationIDs = $(this).data('ids');
    if ($('.notificationContainer').css('visibility') === 'hidden') {
        toggleNotificationList(newNotificationIDs);
    }
}

/**
 *
 * @param {array} newNotificationIDs
 */
function toggleNotificationList(newNotificationIDs) {
    const $NotificationContainer = $('.notificationContainer');
    const $NotificationListContainer = $('.notificationListContainer');
    if (pushNotificationsTotal > 0 && $NotificationContainer.css('visibility') === 'hidden') {
        $NotificationContainer.css('visibility', 'visible');
        $NotificationListContainer.css('display', 'flex');
        $(document).one('mousedown', hideNotificationsList);
    } else if ($NotificationContainer.css('visibility') === 'hidden') {
        $NotificationContainer.css('visibility', 'visible');
        $NotificationListContainer.css('display', 'none');
        $(document).one('mousedown', hideNotificationsList);
    } else {
        $NotificationContainer.css('visibility', 'hidden');
    }
    // Load the initial notifications on the first toggle
    if (pushNotificationsCurrentLength === null) {
        pushNotificationsCurrentLength = 0;
        loadNotificationsList(newNotificationIDs);
    }
}

/**
 *
 * @param {string} token
 * @returns {*}
 */
function updateToken(token) {
    let url = '/common/ajax/popupNotification/popupNotification.php';
    let data = {
        'token': token,
        'updateToken': true
    };
    return $.ajax({
        type: 'POST',
        url: url,
        dataType: "json",
        data: data,
        success: function (response) {
            //set token has been updated to session storage
            sessionStorage.setItem("firebaseTokenUpdated", 'true');
            return response.success;
        },
        error: function () {
            return false;
        }
    });
}

/**
 * @returns {{storageBucket: string, apiKey: string, messagingSenderId: string, appId: string, projectId: string, measurementId: string, databaseURL: string, authDomain: string}}
 */
function getFirebaseConfig() {
    return {
        apiKey: "AIzaSyBBGFOk01Dyw4woyJGk4fn_q-yE9xNhcsQ",
        authDomain: "simpro-mobile.firebaseapp.com",
        projectId: "simpro-mobile",
        databaseURL: "https://simpro-mobile.firebaseio.com",
        storageBucket: "simpro-mobile.appspot.com",
        messagingSenderId: "1089978862541",
        appId: "1:1089978862541:web:7518574129bc54fbafd284",
        measurementId: "G-EKTFVWHJ5H"
    };
}

/**
 * remove notifications from pop up and list
 * @param notificationID
 */
function removeNotificationFromPopupAndList(notificationID) {
    // Remove the popup if it still exists
    let $NotificationPopup = $('#notificationPopup');
    if ($NotificationPopup.length && $('.notificationID' + notificationID, $NotificationPopup).length) {
        $NotificationPopup.remove();
    }

    // Remove the item from the drop down list if it exists
    let $NotificationElement = $('.notificationID' + notificationID);
    if ($NotificationElement.length) {
        $NotificationElement.remove();
    }
    pushNotificationsTotal -= 1;
    pushNotificationsCurrentLength = pushNotificationsTotal > 0 ? pushNotificationsCurrentLength - 1 : null;

    //when no notifications hide the notification list
    if (pushNotificationsTotal === 0) {
        $('.notificationContainer').css('visibility', 'hidden');
    }
    // Update the bubble total, and trigger a scroll event in case the loader came into view
    updatePushNotificationBubble();
    handlePushNotificationContainerScroll();
}

/**
 * Handle the actions related to handover request for project
 * @param e
 */
function notificationHandoverAction(e) {
    e.stopPropagation();
    let notificationID = $(this).data('id');
    let action = $(this).data('action');
    let openHashToClose = '';
    //check click on save and handover action
    if (action === 'finish') {
        // get the project hash related to the notification
        $.ajax('/common/ajax/pushNotification/handoverAccessActions.php', {
            async: false,
            data: {
                "notificationID": notificationID,
                "action": 'fetchOpenhashDetails'
            },
            type: "POST",
            success: function (response) {
                let openHash = getOpenObjectHash();
                openHashToClose = response.openHash;
                // check open project hash and notification related project hash is same
                if (openHashToClose && openHashToClose === openHash) {
                    let $openObjectForm = $('#mainContainer').find('form');
                    //check for the form mandatory field check and submit the form
                    if (checkMandatory($openObjectForm)) {
                        let params = "readOnly=1&save=true";
                        ajaxSubmit($openObjectForm, params);
                        removeNotificationFromPopupAndList(notificationID);
                    }
                } else {
                    action = 'save';
                }
            },
            error: function(jqXHR) {
                const errorResponse = JSON.parse(jqXHR.responseText);
                displayErrorMessages(errorResponse);
            }
        });
    }

    // check handover action is not finish
    if (action !== 'finish') {
        handoverProjectAccessAction(notificationID, action, openHashToClose);
    }
}

/**
 * Call the service and do the action related to the handover
 * @param notificationID
 * @param action
 * @param openHashToClose
 */
function handoverProjectAccessAction(notificationID, action, openHashToClose) {
    let redirect = false;
    let openHash = getOpenObjectHash();
    let closeObject = false;
    //check it is need to close object
    if (openHash === '' || openHash !== openHashToClose) {
        closeObject = true;
    }
    // handle the actions related notification response
    $.ajax('/common/ajax/pushNotification/handoverAccessActions.php', {
        async: false,
        data: {
            "notificationID": notificationID,
            "action": action,
            'openHashToClose': openHashToClose,
            'closeObject': closeObject,
        },
        type: "POST",
        success: function (responseData) {
            let redirectURL = null;
            if (responseData.url) {
                redirectURL = responseData.url;
            }
            let openHashToClose = responseData.openHashToClose;
            if (openHashToClose) {
                // check user in the active project
                if (openHashToClose === openHash) {
                    redirect = true;
                } else {
                    let message = '';
                    if (action === 'handover') {
                        message = gettext('Successfully closed');
                    } else {
                        message = gettext('Successfully saved and closed');
                    }
                    // close quicklink and display success message
                    let context = $("li[class^='quickLinkItem'] span[openhash='" + openHashToClose + "']");
                    context.parent("li#quickLink_" + openHashToClose).remove();
                    window.setTimeout(function () {
                        $("<div id='loadingItems' style='display:none'><div class='lightBox'><span class='icon-tick'></span> " +
                            message + "</div></div>").appendTo("body").fadeIn("2000", function () {
                            $(this).fadeOut("600", function () {
                                $(this).remove();
                            });
                        });
                    }, 1);
                }
            }
            removeNotificationFromPopupAndList(notificationID);
            // redirect to project listing page if redirect required
            if (redirect && redirectURL !== null) {
                window.location.href = redirectURL;
            }
        },
        error: function (errorResponse) {
            const errorResponseData = JSON.parse(errorResponse.responseText);
            displayErrorMessages(errorResponseData);
        }
    });
}

/**
 * if multiple projects open then get the active project openHash details
 */
function getOpenObjectHash() {
    let openHash = '';
    let listItems = $("#quickLink li");
    listItems.each(function (idx, li) {
        if ($(li).hasClass('activeQuickLink')) {
            openHash = $(li).data('open-hash');
        }
    });
    return openHash;
}

/**
 * for handover access notifications hide popup when click 'X' icon
 */
function notificationPopupHide() {
    $('#notificationPopup').hide();
}

/**
 * display error messages
 */
function displayErrorMessages(responseData) {
    let openHashToClose = '';
    if (typeof responseData.openHashToClose !== 'undefined') {
        openHashToClose = responseData.openHashToClose;
    }
    let title = responseData.title;
    let errorMsg = '';
    if (typeof responseData.alertContent !== 'undefined') {
        errorMsg = responseData.alertContent;
    } else {
        errorMsg = '<p>' + (responseData.hasOwnProperty('error')
            ? responseData.error
            : gettext('Unexpected Error')) + '</p>';
    }

    // open project related errors occurred
    if (errorMsg !== '' && openHashToClose !== '') {
        let quickLinkNode = $('#quickLink_' + openHashToClose);
        let tabUrlToClose = $(quickLinkNode).data('url');
        let redirect = tabUrlToClose + '&revalidate=1';
        errorMsg = ''
            + errorMsg
            + '<div class="textCenter">'
            + '<button data-cy="OK_Dialog" type="button" class="btnBlue dialogClose closeQuickLinkValidator" data-url="' + redirect + '">' + sprintf(gettext('Open %s'), title) + '</button>'
            + '</div>';
        createDialog('custom', errorMsg, gettext("Cannot Submit"));
    } else {
        createDialog('custom ', errorMsg, gettext("Unable to find the Project"));
        //if response has notification id clear the notification
        if (responseData.notificationID) {
            let notificationID = responseData.notificationID;
            removeNotificationFromPopupAndList(notificationID);
            delayRemovingPushNotifications(notificationID);
        }
    }

}

/**
 * clear the notification and load the page
 */
function handoverActionOpenProject(e) {
    e.stopPropagation();
    let notificationID = $(this).data('id');
    let url = $(this).data('href');
    showLoadingImage();
    removeNotificationFromPopupAndList(notificationID);
    delayRemovingPushNotifications(notificationID, url);
}

/**
 * show handover access without save confirmation dialog
 */
function showHandoverAccessDialogConfirm(e) {
    $('#notificationPopup').remove();
    closeContextMenu();
    let $NotificationDetails = $(this);
    let closeQuicklinkBtnTemplate = '<button type="button" class="%s" tabindex="%d">%s</button>';
    let saveAndCloseBtn = sprintf(
        closeQuicklinkBtnTemplate,
        'dialogContinue btnRed',
        10000,
        gettext('Handover Without Saving')
    );
    let closeWithoutSaveBtn = sprintf(
        closeQuicklinkBtnTemplate,
        'btnGrey dialogClose marginLeft',
        10000,
        gettext('Cancel')
    );
    let dialogContent = sprintf(
        '<p>%s</p><div class="textCenter doubleMarginTop">%s %s</div>',
        gettext('Are you sure you want to handover access without saving?'),
        saveAndCloseBtn,
        closeWithoutSaveBtn
    );
    let confirmationDialog = createDialog('custom', dialogContent, gettext('Confirm Handover'));
    // let confirmationDialog = createDialogConfirm($(this), false);
    confirmationDialog.on('click', '.dialogContinue', function() {
        $(".dialogBox").remove();
        let notificationID = $NotificationDetails.data('id');
        let action = $NotificationDetails.data('action');
        let openHashToClose = '';
        // get the object hash related to the notification
        $.ajax('/common/ajax/pushNotification/handoverAccessActions.php', {
            data: {
                'notificationID': notificationID,
                'action': 'fetchOpenhashDetails'
            },
            type: 'POST',
            success: function (response) {
                openHashToClose = response.openHash;
                hideLoadingImage();
                //do the handover action
                handoverProjectAccessAction(notificationID, action, openHashToClose);
            },
            error: function(jqXHR) {
                const errorResponse = JSON.parse(jqXHR.responseText);
                hideLoadingImage();
                displayErrorMessages(errorResponse);
            }
        });
    });
    e.stopPropagation();
}
